import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Button from '@mui/material/Button'
import Divider from '@mui/material/Divider'
import IconButton from '@mui/material/IconButton'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import Typography from '@mui/material/Typography'
import { Theme, styled } from '@mui/material/styles'
import { colors } from '@theme/variables'

export const MetaFilterWrapper = styled('button')`
  padding: 0;
  border: none;
  background: none;
  padding: none;
`

export const MetaFilterSelectComponent = styled(Select)`
  background: transparent;
  height: 24px;
  max-width: 305px;

  .MuiOutlinedInput-notchedOutline {
    border: none;
  }
  .MuiSelect-select {
    padding: 0;
  }
`

export const MetaFilterSelectContent = styled('div')`
  display: flex;
  padding: 2px 9px;
  border: 1px solid ${({ $open, $isNewItem }: { $open: boolean; $isNewItem: boolean }) => getBorderColor($open, $isNewItem)};
  background: ${colors.white};
  border-radius: 4px;
  &:hover {
    border-color: ${colors.primaryDark};
  }
`
const getBorderColor = ($open: boolean, $isNewItem: boolean) => {
  if ($isNewItem) return '#0B7CB7'
  return $open ? colors.primaryDark : '#d1d1d1'
}

export const MetaFilterSelectType = styled('div')`
  display: flex;
  align-items: center;
  cursor: pointer;
`

export const MetaFilterDivider = styled(Divider)`
  margin: 0 8px;
  height: 16px;
  align-self: center;
`

export const MetaFilterSelectWrapper = styled('div')`
  display: flex;
`

export const MetaFilterSelectSubmit = styled(Button)`
  padding: 0;
  min-width: 32px;
  min-height: 30px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  margin-left: -5px;
`

export const MetaFilterSelectLabel = styled(Typography)`
  font-weight: ${({ $isDefaultLabel }: { $isDefaultLabel: boolean }) => ($isDefaultLabel ? 400 : 600)};
  ${({ $isNewItemLabel }: { $isNewItemLabel: boolean }) => ($isNewItemLabel ? 'color: #0B7CB7;' : '')}
`

export const MetaFilterSelectIcon = styled(IconButton)`
  padding: 0;
`

export const MetaFilterSelectArrow = styled(ExpandMoreIcon)`
  color: ${colors.black};
`

export const MetaFilterSelectMenuItem = styled(MenuItem)`
  padding: 0;

  &.Mui-selected {
    color: ${({ theme }: { theme: Theme }) => theme.palette.primary.main};
    background: transparent;

    &:hover {
      background: transparent;
    }
  }

  &:hover {
    color: ${({ theme }: { theme: Theme }) => theme.palette.primary.main};
    background: transparent;
  }

  & + & {
    margin-top: 2px;
  }
`
